// removed by extract-text-webpack-plugin
module.exports = {"icon_wrapper":"icon_wrapper"};


//////////////////
// WEBPACK FOOTER
// ./src/view/common/CustomIcon/style.scss
// module id = 1193
// module chunks = 0